import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/facebook.png'
import _imports_1 from '../assets/whatsapp.png'
import _imports_2 from '../assets/Instagram.png'


const _hoisted_1 = { class: "third-box" }
const _hoisted_2 = { class: "children-item1" }
const _hoisted_3 = { class: "inner-container" }
const _hoisted_4 = { class: "child-div child-div1 contact-content" }
const _hoisted_5 = { class: "child-div child-div2" }
const _hoisted_6 = {
  href: "https://www.google.com/maps/dir//DR+MOTOR+LTD,+Kwun+Tong+Promenade,+Kwun+Tong,+Hong+Kong",
  target: "_blank",
  class: "navigate-button"
}

import { useI18n } from 'vue-i18n';

export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalFooter',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  const _component_el_footer = _resolveComponent("el-footer")!

  return (_openBlock(), _createBlock(_component_el_footer, { class: "global-footer" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", null, _toDisplayString(_unref(t)('contactTitle')), 1),
              _createElementVNode("p", null, "📞 " + _toDisplayString(_unref(t)('phone1')), 1),
              _createElementVNode("p", null, "💬 " + _toDisplayString(_unref(t)('phone2')), 1),
              _cache[0] || (_cache[0] = _createElementVNode("p", null, "📧 cs@drmotor.hk", -1)),
              _createElementVNode("p", null, "📍 " + _toDisplayString(_unref(t)('address')), 1),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "social-media-icons" }, [
                _createElementVNode("a", {
                  href: "https://www.facebook.com/profile.php?id=61577205355724",
                  target: "_blank",
                  class: "social-icon",
                  title: "Facebook"
                }, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "Facebook"
                  })
                ]),
                _createElementVNode("a", {
                  href: "whatsapp://send?phone=+85266860815",
                  target: "_blank",
                  class: "social-icon",
                  title: "WhatsApp"
                }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "WhatsApp"
                  })
                ]),
                _createElementVNode("a", {
                  href: "https://www.instagram.com/dr_moto_ev_hk_ltd/",
                  target: "_blank",
                  class: "social-icon",
                  title: "Instagram"
                }, [
                  _createElementVNode("img", {
                    src: _imports_2,
                    alt: "Instagram"
                  })
                ])
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[2] || (_cache[2] = _createElementVNode("iframe", {
                width: "100%",
                height: "100%",
                frameborder: "0",
                style: {"border":"0"},
                loading: "lazy",
                allowfullscreen: "",
                "aria-hidden": "false",
                tabindex: "0",
                src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.0847162179427!2d114.23822611526445!3d22.311846648358146!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340400634d6b136f%3A0xc80992f7c9449a12!2sDR%20MOTOR%20LTD!5e0!3m2!1szh-CN!2shk!4v1623456789012"
              }, null, -1)),
              _createElementVNode("a", _hoisted_6, _toDisplayString(_unref(t)('startNavigation')), 1)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})